var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { USDZExporter, USDZExporter as Exporter } from 'three/examples/jsm/exporters/USDZExporter';
export class UsdzExporter {
    constructor() {
        this.exporter = new Exporter();
    }
    export(scene) {
        return __awaiter(this, void 0, void 0, function* () {
            const exporter = new USDZExporter();
            const arraybuffer = yield exporter.parseAsync(scene);
            return new Blob([arraybuffer], { type: 'application/octet-stream' });
        });
    }
}
//# sourceMappingURL=UsdzExporter.js.map